import React, {useState} from "react";
import {dataForSelect, deleteItem, saveData} from "../../../helpers/Api";
import {Button, Col, Row} from "react-bootstrap";
import FlashMessage from "../../shared/FlashMessage";
import ListTable from "../../shared/ListTable";
import {DeleteButton} from "../../../helpers/ButtonHelper";
import {useMutation, useQuery} from "@apollo/client";
import {
  createBadIngredientMutation,
  deleteBadIngredientMutation,
  getBadIngredientsQuery, getClientIngredientsQuery
} from "./BadIngredientsQueries";
import Select from "react-select";

const BadIngredientsList = ({ user }) => {
  const { data: ingredientsData, loading: ingredientsLoading } = useQuery(getClientIngredientsQuery)
  const { data, loading, refetch } = useQuery(getBadIngredientsQuery, { variables: { clientId: user.id } })
  const [flash, setFlash] = useState({});
  const [deleteCall] = useMutation(deleteBadIngredientMutation, { refetchQueries: refetch })
  const [saveCall] = useMutation(createBadIngredientMutation)
  const selectRef = React.useRef();

  const onSubmit = (event) => {
    event.preventDefault()
    saveData({
      event: event,
      gqlCall: saveCall,
      query_key: 'createBadIngredient',
      flash_callback: setFlash,
      success: (res) => {
        refetch()
        event.target.reset()
        selectRef.current.setValue(null)
      }
    })
  }

  let hideIds = []
  if (!loading)
    hideIds = data.badIngredients.map(a => a.ingredient.id)

  let selectIngredients = []
  if (!ingredientsLoading)
    selectIngredients = ingredientsData.clientIngredients.filter(a => !hideIds.includes(String(a.id)))

  const header = <tr>
    <th>Ingredient</th>
    <th>Detalii</th>
    <th className='actions'></th>
  </tr>

  const listItem = (item, index) => {
    return <tr key={index}>
      <td>{item.ingredient.name}</td>
      <td>{item.details}</td>
      <td className='actions'>
        <DeleteButton onClick={e => deleteItem(e, item.id, deleteCall)} />
      </td>
    </tr>
  }

  return (
    <div className="container">
      <form onSubmit={onSubmit}>
        <Row className="mb-2">
          <Col>
            <FlashMessage flash={flash} />
          </Col>
        </Row>
        <Row className="mb-2">
          <Col sm>
            <label htmlFor="name">Ingredient:</label>
            <input type='hidden' name='clientId' className="form-control" id="clientId" value={user.id} />
            {!ingredientsLoading && selectIngredients &&
              <Select name='ingredientId' id='ingredientId' ref={selectRef} className="basic-single"
                      options={ingredientsData.clientIngredients && dataForSelect(selectIngredients)}
              />
            }
          </Col>
          <Col>
            <label htmlFor="level">Detalii:</label>
            <input type='text' name='details' className="form-control" id="details" />
          </Col>
          <Col className="col-auto">
            <br />
            <Button type='submit'>Adauga</Button>
          </Col>
        </Row>
      </form>
      <hr />

      {!loading &&
        <ListTable data={data.badIngredients} header={header} listItem={listItem} showSearch={false} />
      }
    </div>
  );
}

export default BadIngredientsList
